<template>
  <div class="row">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create Term</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Vocabulary *</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.vocabulary"
                      :default-options="vocabularyOptionsDefault"
                      :search-function="vocabularySearch"
                      label="name"
                    />
                  </div>
                </div>

                <div v-if="entity.vocabulary" class="form-group row">
                  <label for="bio" class="col-md-2">Parent Term</label>
                  <div class="col-md-10">
                    <vue-select
                      v-model="entity.parent"
                      :filterable="false"
                      :options="parentOptions"
                      @search="onParentSearch"
                    >
                      <template slot="no-options">
                        No results. Type to search...
                      </template>
                      <template slot="option" slot-scope="option">
                        {{ option.name }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.name }}
                      </template>
                    </vue-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Term has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import SelectRemote from '@/global/components/SelectRemote';
import VueSelect from 'vue-select';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'TermNew',

  components: {
    'select-remote': SelectRemote,
    'vue-select': VueSelect,
  },

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        name: null,
        vocabulary: null,
        parent: null,
      },
      vocabularyOptionsDefault: [],
      parentOptions: [],
    };
  },

  watch: {
    'entity.vocabulary': {
      handler() {
        this.entity.parent = null;
        this.parentOptions = [];
      },
    },
  },

  mounted() {
    this.getDefaultvocabulary();
  },

  methods: {
    getDefaultvocabulary() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}vocabularies`)
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.vocabularyOptionsDefault = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    vocabularySearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}vocabularies?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((reject) => {
          console.error(reject);
        });
    }, 350),
    onParentSearch(search, loading) {
      loading(true);
      this.parentSearch(loading, search, this);
    },
    parentSearch: _.debounce((loading, search, vm) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}terms`, {
        params: {
          vid: vm.entity.vocabulary.id,
          search_string: escape(search),
        },
      })
        .then((response) => {
          const newDataArr = [];
          _.forIn(response.data, (value, key) => {
            if (key !== 'meta' && value.id !== vm.$route.params.id) {
              newDataArr.push(value);
            }
          });
          context.parentOptions = newDataArr;
          loading(false);
        })
        .catch((reject) => {
          console.error(reject);
        });
    }, 350),
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.vocabulary) {
        this.$_showError('Vocabulary field is required');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('vid', this.entity.vocabulary.id);
      if (this.entity.parent) postFormData.append('parent_id', this.entity.parent.id);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}terms`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/taxonomy/terms/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create term query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?3d0ed726